
// 用户系别枚举
export const sexType = val => {
  switch (val) {
    case 1:
      return '男';
      break;
    case 2:
      return '女';
      break;
    case 3:
      return '未知';
      break;
    default:
      break;
  }
};
// 优惠券类型
export const couponType = val => {
  switch (val) {
    case 0:
      return '满减券';
      break;
    case 1:
      return '折扣券';
      break;
    case 2:
      return '无门槛';
      break;
    default:
      break;
  }
};
// 优惠券状态
export const couponStatus = val => {
  switch (val) {
    case 0:
      return '未使用';
      break;
    case 1:
      return '已使用';
      break;
    case 2:
      return '已过期';
      break;
    case 3:
      return '已失效';
      break;
    default:
      break;
  }
};

const couponChannelType = val => {
  switch (val) {
    case 'online': return '小程序';
    case 'jiezhou': return '芥舟';
    default : return '小程序'
  }
}

export default {
  sexType,
  couponType,
  couponStatus,
  couponChannelType,
};
